import { Button, keyframes } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

const _dark = clientThemePalette[CLIENT_THEME].dark;

// Keyframe animations
export const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 ${alpha(_dark.primary, 0.7)};
  }
  70% {
    box-shadow: 0 0 0 20px ${alpha(_dark.primary, 0)};
  }
  100% {
    box-shadow: 0 0 0 0 ${alpha(_dark.primary, 0)};
  }
`;

const float = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
`;

const glow = keyframes`
  0%, 100% {
    filter: drop-shadow(0 0 5px ${alpha(_dark.primary, 0.5)});
  }
  50% {
    filter: drop-shadow(0 0 20px ${alpha(_dark.primary, 0.8)});
  }
`;

// Styled animated button
export const RunButton = styled(Button)<{ isExpanded: boolean }>(
  ({ isExpanded }) => ({
    position: 'relative',
    padding: isExpanded ? '8px 8px' : '16px 32px',
    fontSize: isExpanded ? '14px' : '18px',
    fontWeight: 700,
    textTransform: 'none',
    borderRadius: '50px',
    background: `linear-gradient(135deg, ${_dark.primary} 0%, ${_dark.primaryDark} 50%, ${_dark.primary} 100%)`,
    border: 'none',
    color: 'white',
    cursor: 'pointer',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    animation: `${float} 3s ease-in-out infinite, ${glow} 2s ease-in-out infinite`,
    boxShadow: `0 8px 32px ${alpha(_dark.primary, 0.3)}`,
    backdropFilter: 'blur(10px)',
    '&:hover': {
      background: `linear-gradient(135deg, ${_dark.primaryDark} 0%, ${_dark.primary} 50%, ${_dark.primaryDark} 100%)`,
      transform: 'translateY(-5px) scale(1.05)',
      boxShadow: `0 15px 40px ${alpha(_dark.primary, 0.4)}`,
      animation: `${pulse} 1.5s infinite`,
    },
    '&:active': {
      transform: 'scale(0.98)',
      transition: 'all 0.1s ease',
    },
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      borderRadius: '50px',
      background:
        'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%)',
      opacity: 0,
      transition: 'opacity 0.3s ease',
    },
    '&:hover::before': {
      opacity: 1,
    },
    '& .MuiButton-label': {
      position: 'relative',
      zIndex: 1,
    },
  })
);
